<template>
  <div class='ProdBtn02'>
    <component
    :is="Prefes.cart.icon"
    :color="Prefes.produto.corFont"
    :tam="'30px'"
    :count="false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { icons } from '@/components/icons'
export default {
  name: 'ProdBtn02',
  components: { ...icons },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.ProdBtn02 {
  width: 50%;
  display: flex;
  justify-content: end;
}
</style>
